export const styles = {
  root: {
    fontFamily: 'Proxima Nova, Helvetica, Arial, sans-serif',
    '& .MuiSnackbar-root': {
      borderRadius: '4px',
      border: '1px solid #E2E2FC',
      boxShadow: '0px 2px 14px rgba(39, 55, 84, 0.08)',
      fontFamily: 'Proxima Nova, Helvetica, Arial, sans-serif',
    },

    '& .MuiAlert-root': {
      display: 'flex',
      alignItems: 'flex-start',
      color: '#011533',
      padding: '12px 16px',
      background: '#FFFFFF',
      fontFamily: 'Proxima Nova, Helvetica, Arial, sans-serif',
    },

    '& .MuiAlert-icon': {
      display: 'none',
    },

    '& .MuiAlert-action': {
      marginRight: '0px',
      paddingTop: '8px',
      '& button': {
        padding: '0px',
      },
    },

    '& .MuiAlert-message': {
      fontSize: '16px',
      fontWeight: '100',
      fontFamily: 'Proxima Nova, Helvetica, Arial, sans-serif',
    },
  },

  noBorder: {
    '& > .MuiSnackbar-root': {
      border: 'none',
    },
  },

  paddingTop: {
    '& > .MuiSnackbar-root': {
      top: '81px',
    },
  },
  paddingTop73: {
    '& > .MuiSnackbar-root': {
      top: '73px',
    },
  },

  undoIcon: {
    '& > .MuiButton-root': {
      '& > span': {
        textTransform: 'none',
        fontWeight: '700',
        fontSize: '16px',
        lineHeight: '20px',
      },
    },
  },

  closeIcon: {
    '& > .MuiButton-root': {
      minWidth: '20px',
      padding: '0 8px',
      height: '100%',
    },
  },

  btnsSeparator: {
    width: '1px',
    height: '26px',
    background: '#526181',
    margin: 'auto',
  },

  snackbarMessage: {
    display: 'flex',
    alignItems: 'center',
    maxWidth: '341px',

    '& svg': {
      marginRight: '10px',
    },
  },
}
